import { exhaustiveCheck } from '@famly/stat_ts-utils_exhaustive-check';
export const getNavigationLinkRouteConfig = (navigationLinkId) => {
    switch (navigationLinkId) {
        // --- Get started onboarding links ---
        case 'NURSERY_INFO':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/info',
                },
            };
        case 'MANAGE_GROUP_RULES':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/manageGroupRules',
                },
            };
        case 'GET_STARTED_CHILDREN':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/manageChildren',
                },
            };
        case 'CHILD_IMPORT_V2':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/child-import-v2',
                },
            };
        case 'CHILD_IMPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childImport',
                },
            };
        case 'STAFF_ROLES':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/manageEmployeeRights/roles',
                },
            };
        case 'STAFF_PERMISSIONS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/manageEmployeeRights/permissions',
                },
            };
        case 'FINANCE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/finance',
                },
            };
        case 'PRICING':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/itemsAndPricing',
                },
            };
        // --- Navigation group: Home ---
        case 'OVERVIEW':
            return {
                organizationRoute: {
                    path: '/account/organization/:organizationId',
                },
                institutionRoute: {
                    path: '/account/institution/:institutionId',
                },
            };
        case 'HOME_CUSTOMIZATION':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/customization',
                },
            };
        case 'CHILDREN_AND_STAFF':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/:type/:id/childrenAndStaff',
                },
            };
        case 'ORGANIZATION_SETTINGS':
            return {
                organizationRoute: {
                    path: '/account/organization/:organizationId/settings',
                },
            };
        case 'OVERVIEW_REPORTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/lists',
                },
            };
        case 'NEWS_FEED':
            return {
                topLevelRoute: {
                    path: '/account/feed',
                },
                institutionRoute: {
                    path: '/account/institution/:institutionId/feed',
                },
                customEntityRoutes: [
                    {
                        id: 'NEWS_FEED_MY_NEWS',
                        path: '/account/feed/me',
                    },
                    {
                        id: 'NEWS_FEED_BOOKMARKS',
                        path: '/account/feed/bookmarks',
                    },
                ],
            };
        case 'NEWS_FEED_SINGLE_POST':
            return {
                topLevelRoute: {
                    path: '/account/posts/:postId',
                },
            };
        case 'CHILDREN':
        case 'CHILDREN_OVERVIEW':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childrenOverview',
                },
            };
        // Route config only — never emitted into the sidebar. It exists so the superseded
        // children list still resolves a topbar title when someone reaches it by URL;
        // `CHILDREN` would resolve the safeguarding title instead.
        case 'CHILDREN_OVERVIEW_LEGACY':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/children',
                },
            };
        case 'KIVAN_IMPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/kivan-import-v2',
                },
            };
        case 'PARENTAL_PERMISSIONS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/permissions',
                },
            };
        case 'PARENTAL_PERMISSIONS_CHECK_PERMISSIONS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/permissions/matrix',
                },
            };
        case 'PARENTAL_PERMISSIONS_MANAGE_V3':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/permissions/manage',
                },
            };
        case 'VACATION_PLANS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/vacationPlanning',
                },
            };
        case 'VACATION_PERIOD':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/vacationPeriod/:vacationId',
                },
            };
        case 'STAFF':
        case 'STAFF_V3':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/staff',
                },
            };
        case 'STAFF_ROLES_V3':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/staff/roles',
                },
            };
        case 'SIDEKICK':
        case 'SIDEKICK_AUTOMATIONS':
            return {
                topLevelRoute: {
                    path: '/account/sidekick',
                },
            };
        case 'SIDEKICK_PREFERENCES':
            return {
                topLevelRoute: {
                    path: '/account/sidekick/preferences',
                },
            };
        case 'DOCUMENTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/files',
                },
            };
        case 'STAFF_DOCUMENTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/files/staffDocuments',
                },
            };
        case 'PARENT_DOCUMENTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/files/parentDocuments',
                },
            };
        case 'CONTRACT_TEMPLATES':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/files/contract-templates',
                },
            };
        case 'CONTRACTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/files/contracts',
                },
            };
        case 'CONTRACT_TEMPLATE_BUILDER':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/contract-template/:templateId',
                },
            };
        case 'EMPLOYEE_TODOS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/employeeTodos',
                },
            };
        case 'CALENDAR':
            return {
                topLevelRoute: {
                    path: '/account/calendar',
                },
                institutionRoute: {
                    path: '/account/institution/:institutionId/calendar',
                },
                customEntityRoutes: [
                    {
                        id: 'MY_CALENDAR',
                        path: '/account/calendar/me',
                    },
                ],
            };
        case 'CALENDAR_EVENT':
            return {
                topLevelRoute: {
                    path: '/account/event/:eventId',
                },
            };
        case 'OLD_MEAL_PLANS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/mealPlan/oldVersion',
                },
            };
        case 'MEALS':
        case 'MEAL_PLANS_V3':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/mealPlan',
                },
            };
        case 'MEAL_PLANS_V3_CREATE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/mealPlan/create',
                },
            };
        case 'MEAL_PLANS_V3_VIEW':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/mealPlan/:mealPlanId',
                },
            };
        case 'MEAL_BOOKINGS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/mealBooking',
                },
            };
        case 'BILL_PAYER':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/billPayer/:billPayerId',
                },
            };
        case 'BILL_PAYERS':
            return {
                institutionRoute: {
                    path: '/account/balances/:loginId',
                },
            };
        case 'LESSON_PLANS_PARENT':
            return {
                topLevelRoute: {
                    path: '/account/lessonPlans',
                },
            };
        // --- Navigation group: Registers ---
        case 'ROOMS':
        case 'ROOM_PLANNING':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/roomPlanning',
                },
            };
        case 'ATTENDANCE_REPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/attendance',
                },
            };
        case 'STAFFING':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/staffing',
                },
            };
        case 'STAFF_RATIO_REPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/staffing/staffRatioReport',
                },
            };
        case 'STAFFING_STAFF_ATTENDANCE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/staffing/attendance',
                },
            };
        case 'SCHEDULES':
        case 'STAFFING_STAFF_SCHEDULE_V2':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/staffing/staffSchedule',
                },
            };
        case 'STAFF_ATTENDANCE_DETAILS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/staffing/attendance/details',
                },
            };
        case 'STAFFING_STAFF_HOURS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/staffing/staffHours',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/staffing/staffHours',
                },
            };
        case 'STAFFING_STAFF_LEAVE_V2':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/staffing/staffLeaveV2',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/staffing/staffLeaveV2',
                },
            };
        case 'INQUIRIES_V2':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/inquiries',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/inquiries',
                },
            };
        case 'OCCUPANCY':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/occupancy',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/occupancy',
                },
            };
        case 'REGISTRATION':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/occupancyPlanner',
                },
            };
        case 'OCCUPANCY_PLANNER':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/occupancyPlanner',
                },
            };
        case 'OCCUPANCY_INDEX':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/occupancy',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/occupancy',
                },
            };
        // --- Navigation group: Learning ---
        case 'CHILD_DEVELOPMENT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childDevelopment',
                },
            };
        case 'CHILD_DEVELOPMENT_OVERVIEW':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childDevelopment',
                },
            };
        case 'CHILD_DEVELOPMENT_NEXT_STEPS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childDevelopment/nextSteps',
                },
            };
        case 'CHILD_DEVELOPMENT_PROGRESS_REPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childDevelopment/progressReport',
                },
            };
        case 'CHILD_DEVELOPMENT_COMPARE_COHORTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childDevelopment/cohortCompare',
                },
            };
        case 'CHILD_DEVELOPMENT_TALLY':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childDevelopment/tally',
                },
            };
        case 'CHILD_DEVELOPMENT_TWO_YEAR_CHECKS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childDevelopment/twoYearChecks',
                },
            };
        case 'CHILD_DEVELOPMENT_GROUP_OBSERVATION':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childDevelopment/groupObservation',
                },
            };
        case 'CURRICULUM_BUILDER_LIST':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/curriculums',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/curriculums',
                },
            };
        case 'CURRICULUM_BUILDER_CREATE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/curriculums/create',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/curriculums/create',
                },
            };
        case 'CURRICULUM_BUILDER_DUPLICATE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/curriculums/create/:curriculumId',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/curriculums/create/:curriculumId',
                },
            };
        case 'CURRICULUM_BUILDER_SHOW':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/curriculums/:curriculumId',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/curriculums/:curriculumId',
                },
            };
        case 'CURRICULUM_LIST':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/curriculumsList',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/curriculumsList',
                },
            };
        case 'CURRICULUM_SHOW':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/curriculumsList/:curriculumId',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/curriculumsList/:curriculumId',
                },
            };
        case 'ACTIVITY_LIBRARY':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/activities',
                },
            };
        case 'ACTIVITY_LIBRARY_SINGLE_LIBRARY': {
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/activities/library/:libraryId',
                },
            };
        }
        case 'ACTIVITY_LIBRARY_SINGLE_ACTIVITY': {
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/activities/activity/:id',
                },
            };
        }
        case 'RESOURCE_LIBRARY':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/resourceLibrary',
                },
            };
        case 'RESOURCE_LIBRARY_SINGLE_RESOURCE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/resourceLibrary/resource/:resourceId',
                },
            };
        case 'LESSON_PLANS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/lessonPlans',
                },
            };
        // --- Navigation group: Safeguarding ---
        case 'ACCIDENTS_INCIDENTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/safeguarding',
                },
            };
        case 'MEDICATION_FORMS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/medicationForms',
                },
            };
        case 'IMMUNIZATION':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/immunizations',
                },
            };
        case 'IMMUNIZATION_ONBOARDING':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/immunizations/onboarding',
                },
            };
        case 'CHILD_ADDITIONAL_NEEDS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childAdditionalNeeds',
                },
            };
        case 'HEAD_COUNT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/headcount',
                },
            };
        // --- Navigation group: Finance ---
        case 'REVENUE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/revenueReport',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/revenueReport',
                },
            };
        case 'DEBT_COLLECTION':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/debtCollection',
                },
            };
        case 'PAYMENTS_HEADER':
        case 'PAYMENTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/payments',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/payments',
                },
            };
        case 'IN_APP_PAYMENT_PAYOUTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/inAppPaymentPayouts',
                },
            };
        case 'SUBSIDIES':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/subsidies',
                },
            };
        case 'SUBSIDIES_NEW_PAYOUT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/subsidies/add-payout',
                },
            };
        case 'INVOICES_REPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/invoicesReport',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/invoicesReport',
                },
            };
        case 'BILL_PAYERS_REPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/billPayersReport',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/billPayersReport',
                },
            };
        case 'DEPOSITS_REPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/depositsReport',
                },
            };
        case 'DIRECT_DEBITS_REPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/directDebitsReport',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/directDebitsReport',
                },
            };
        case 'INVOICING':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/batchInvoice',
                },
            };
        case 'INVOICING_REPORTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/financeReports',
                },
            };
        case 'PUBLIC_FUNDING':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/publicFundingReport',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/publicFundingReport',
                },
            };
        case 'CHILD_BASED_FUNDING':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/funding',
                },
            };
        case 'FAMLY_PAY':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/famlyPay',
                },
            };
        case 'BULK_IMPORT_PAYMENT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/importPayments',
                },
            };
        case 'BULK_IMPORT_PAYMENT_PROTOPAYMENTS_TABLE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/importPayments/protoPayments/:paymentsFeedId',
                },
            };
        case 'BOOKINGS':
        case 'PLANS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/bookings',
                },
            };
        case 'PURCHASES':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/bookings/purchases',
                },
            };
        case 'BOOKING_PATTERN_BUILDER':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/bookingPatternBuilder',
                },
            };
        case 'LISTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/lists',
                },
            };
        case 'LISTS_FILTER':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/lists/list-filter',
                },
            };
        case 'HEAD_COUNT_REPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/headcountReport',
                },
            };
        case 'OCCUPANCY_REPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/occupancyReport',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/occupancyReport',
                },
            };
        case 'FORMS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/forms',
                },
            };
        case 'PARENT_TO_DO_LISTS':
            return {
                organizationRoute: {
                    path: '/account/organization/:organizationId/parentToDoLists',
                },
            };
        case 'PARENT_TASK_LIST':
            return {
                organizationRoute: {
                    path: '/account/organization/:organizationId/parentToDoLists/list/:taskListId',
                },
            };
        case 'CRF_NEW_FORM':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/forms/newForm',
                },
            };
        case 'FORM_SUBMISSION_RESPONSE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/forms/:formId/submissionResponse/:submissionId',
                },
            };
        case 'FORM_BUILDER':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/forms/builder/:formId',
                },
            };
        case 'CUSTOM_INQUIRY_FORM_AUTHENTICATED':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/forms/submit/:formId/for/:childId',
                },
            };
        case 'KINDER_CONNECT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/attendance/kinderConnect',
                },
            };
        case 'KINDER_CONNECT_LINKING':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/attendance/kinderConnect/:yearMonth',
                },
            };
        case 'KINDER_CONNECT_EXPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/attendance/kinderConnect/:yearMonth/export',
                },
            };
        case 'FAMLY_REPORT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/appReport',
                },
            };
        case 'ORG_BALANCE_REPORT':
            return {
                organizationRoute: {
                    path: '/account/organization/:organizationId/balanceReport',
                },
            };
        case 'FAMLY_INSIGHTS':
            return {
                organizationRoute: {
                    path: '/account/organization/:organizationId/insights',
                },
            };
        case 'ORG_DASHBOARD':
            return {
                organizationRoute: {
                    path: '/account/organization/:organizationId/dashboard',
                },
            };
        // --- Navigation group: Settings ---
        case 'SETTINGS':
            return {
                topLevelRoute: {
                    path: '/account/settings',
                },
            };
        case 'ORG_SETTINGS':
            return {
                organizationRoute: {
                    path: '/account/organization/:organizationId/orgSettings',
                },
            };
        case 'SETTINGS_TABS':
            return {
                topLevelRoute: {
                    path: '/account/settings',
                },
            };
        case 'SET_CUSTOM_CARE_GROUP':
            return {
                topLevelRoute: {
                    path: '/account/settings/customCareGroups/:customCareGroupId',
                },
            };
        case 'SET_AGE_GROUPS':
            return {
                topLevelRoute: {
                    path: '/account/settings/ageGroups/:institutionId',
                },
            };
        case 'ACCOUNT_SETTINGS':
            return {
                topLevelRoute: {
                    path: '/account/accountSettings',
                },
            };
        case 'ACCOUNTING_SETTINGS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/accountingSettings',
                },
            };
        case 'NEW_STARTERS_ONBOARDING':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/newStartersOnboarding',
                },
                organizationRoute: {
                    path: '/account/organization/:organizationId/newStartersOnboarding',
                },
            };
        // --- Navigation group: Store ---
        case 'FEATURE_STORE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/famlyStore/featureStore',
                },
            };
        case 'STORE_FEATURES':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/famlyStore',
                },
            };
        case 'FAMLY_STORE_TEMPLATES':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/famlyStore/templates',
                },
            };
        case 'FAMLY_STORE_EMBED_PACKAGE_PRICING_PAGE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/famlyStore/packagePricing',
                },
            };
        case 'NOTIFICATIONS':
            return {
                topLevelRoute: {
                    path: '/account/notifications',
                },
            };
        case 'INBOX':
            return {
                topLevelRoute: {
                    path: '/account/inbox',
                },
            };
        // --- Child profile ---
        case 'CHILD_PROFILE_ACTIVITY': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/activity',
                },
            };
        }
        case 'CHILD_PROFILE_ABOUT': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/about',
                },
            };
        }
        case 'CHILD_PROFILE_SLEEP': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/sleep',
                },
            };
        }
        case 'CHILD_PROFILE_INSTITUTION_INFO': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/institutionInfo',
                },
            };
        }
        case 'CHILD_PROFILE_LEAVE': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/leave',
                },
            };
        }
        case 'CHILD_PROFILE_PHOTOS': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/photos',
                },
            };
        }
        case 'CHILD_PROFILE_PLANS': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/childProfilePlans',
                },
            };
        }
        case 'CHILD_PROFILE_BILLING': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/childProfileBilling',
                },
            };
        }
        case 'CHILD_PROFILE_RELATIONS': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/childProfileRelations',
                },
            };
        }
        case 'CHILD_PROFILE_FAMILY': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/family',
                },
            };
        }
        case 'CHILD_PROFILE_PLANS_AND_INVOICES': {
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/plansAndInvoices',
                },
            };
        }
        case 'CHILD_PROFILE_NOTES':
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/childProfileNotes',
                },
            };
        case 'CHILD_PROFILE_NOTE':
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/childProfileNotes/:noteId',
                },
            };
        case 'CHILD_PROFILE_LEARNING_JOURNEY':
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/childProfileLearningJourney',
                },
            };
        case 'CHILD_PROFILE_LEARNING_JOURNEY_OBSERVATION':
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/childProfileLearningJourney/:observationId',
                },
            };
        case 'CHILD_PROFILE_LEARNING_JOURNEY_DETAILS':
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/childProfileLearningJourneyDetails',
                },
            };
        case 'CHILD_PROFILE_SAFEGUARDING':
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/safeguarding',
                },
            };
        case 'CHILD_PROFILE_PRINT_PREVIEW':
            return {
                topLevelRoute: {
                    path: '/account/childProfile/:childId/printPreview',
                },
            };
        // --- Employee profile ---
        case 'EMPLOYEE_PROFILE_DATA':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/employee/:employeeId/employeeData',
                },
            };
        case 'EMPLOYEE_PROFILE_ABOUT':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/employee/:employeeId/about',
                },
            };
        case 'EMPLOYEE_PROFILE_LEAVE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/employee/:employeeId/employeeLeave',
                },
            };
        case 'EMPLOYEE_PROFILE_RELATIONS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/employee/:employeeId/employeeRelations',
                },
            };
        case 'EMPLOYEE_PROFILE_CALENDAR':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/employee/:employeeId/employeeCalendar',
                },
            };
        case 'FINANCE_ONBOARDING':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/financeOnboarding',
                },
            };
        case 'NO_ACCESS':
            return {
                topLevelRoute: {
                    path: '/account/institution/:institutionId/noAccess',
                },
            };
        case 'MOBILE_MENU': {
            return {
                topLevelRoute: {
                    path: '/account/navigationV2MobileMenu',
                },
            };
        }
        case 'MOBILE_MENU_NAVIGATION_GROUP': {
            return {
                topLevelRoute: {
                    path: '/account/navigationV2MobileMenu/navigationGroup/:groupId',
                },
            };
        }
        case 'ATTENDANCE_STATISTICS': {
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/attendanceStatistics',
                },
            };
        }
        case 'BULK_PATTERN_FLOW':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/bulkPatternFlow',
                },
            };
        case 'SUBSCRIPTION':
            return {
                topLevelRoute: {
                    path: '/account/subscription',
                },
            };
        case 'REPORTS':
            return {
                topLevelRoute: {
                    path: '/account/reports',
                },
            };
        case 'REPORTS_OVERVIEW':
            return {
                topLevelRoute: {
                    path: '/account/reports/overview',
                },
            };
        case 'NEW_REPORT':
            return {
                topLevelRoute: {
                    path: '/account/reports/report/:reportId',
                },
            };
        case 'CREATE_NEW_REPORT':
            return {
                topLevelRoute: {
                    path: '/account/reports/new',
                },
            };
        case 'CREATE_NEW_REPORT_FROM_DATASET':
            return {
                topLevelRoute: {
                    path: '/account/reports/new/fromDataset/:datasetId',
                },
            };
        case 'CREATE_NEW_REPORT_FROM_REPORT_TEMPLATE':
            return {
                topLevelRoute: {
                    path: '/account/reports/new/fromReportTemplate/:reportTemplateId',
                },
            };
        case 'REPORT_CATEGORY':
            return {
                topLevelRoute: {
                    path: '/account/reports/categories/:categoryId',
                },
            };
        case 'REPORT':
            return {
                topLevelRoute: {
                    path: '/account/reports/categories/:categoryId/reports/:reportId',
                },
            };
        case 'REPORT_LIST':
            return {
                topLevelRoute: {
                    path: '/account/reports/lists',
                },
            };
        case 'REPORT_LIST_FILTER':
            return {
                topLevelRoute: {
                    path: '/account/reports/lists/list-filter',
                },
            };
        case 'REPORT_FAMLY_INSIGHTS':
            return {
                topLevelRoute: {
                    path: '/account/reports/famlyInsights',
                },
            };
        case 'REPORT_REPORTING':
            return {
                topLevelRoute: {
                    path: '/account/reports/reporting',
                },
            };
        case 'FINANCE_REPORTS':
            return {
                topLevelRoute: {
                    path: '/account/financeReports',
                },
            };
        case 'FINANCE_REPORT':
            return {
                topLevelRoute: {
                    path: '/account/financeReports/:reportId',
                },
            };
        case 'LEARNING_REPORTS':
            return {
                topLevelRoute: {
                    path: '/account/learningReports',
                },
            };
        case 'LEARNING_REPORT':
            return {
                topLevelRoute: {
                    path: '/account/learningReports/:reportId',
                },
            };
        case 'ATTENDANCE_REPORTS':
            return {
                topLevelRoute: {
                    path: '/account/attendanceReports',
                },
            };
        case 'REPORTS_ATTENDANCE_REPORT':
            return {
                topLevelRoute: {
                    path: '/account/attendanceReports/:reportId',
                },
            };
        case 'PARENT_HOME':
            return {
                topLevelRoute: {
                    path: '/account/home',
                },
            };
        case 'PARENT_HOME_SINGLE_CATEGORY':
            return {
                topLevelRoute: {
                    path: '/account/home/resourceCategories/:resourceCategoryName',
                },
            };
        case 'PARENT_HOME_SINGLE_RESOURCE':
            return {
                topLevelRoute: {
                    path: '/account/home/resources/:resourceId',
                },
            };
        case 'FINANCE_LANDING_PAGE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/financeLandingPage',
                },
            };
        case 'ATTENDANCE_LANDING_PAGE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/attendanceLandingPage',
                },
            };
        case 'LEARNING_LANDING_PAGE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/learningLandingPage',
                },
            };
        case 'CHILDREN_LANDING_PAGE':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/childrenLandingPage',
                },
            };
        case 'HEALTH_SCREENING_STATEMENTS':
            return {
                institutionRoute: {
                    path: '/account/institution/:institutionId/manageCheckinStatements',
                },
            };
        default:
            exhaustiveCheck(navigationLinkId);
            // We should never get here
            return { topLevelRoute: { path: '/' } };
    }
};
